import {
   Button,
   Box,
   Container,
   Typography,
   Grid,
   Card,
   CardContent,
   AppBar,
   Toolbar,
   Chip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import {
   CalendarToday as Calendar,
   PhotoCamera as Camera,
   Place as MapPin,
   People as Users,
   QrCode2 as QrCode,
   ConfirmationNumber as Ticket,
   Flight as Plane,
   Image as ImageIcon,
   AccountCircle as UserCircle,
   Share as Share2,
   Check,
   Star,
   ArrowForward as ArrowRight,
   Business as Building2,
   Celebration as PartyPopper,
   Favorite as Heart,
   FitnessCenter as Dumbbell,
   Work as Briefcase,
   TrackChanges as Target,
} from '@mui/icons-material';

export default function Home() {
   const navigate = useNavigate();

   const scrollToSection = (sectionId: string) => {
      const element = document.getElementById(sectionId);
      if (element) {
         element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
   };

   return (
      <div className='min-h-screen' style={{ backgroundColor: '#F9FAFB' }}>
         {/* Navigation */}
         <AppBar
            position='fixed'
            sx={{
               background: 'rgba(255, 255, 255, 0.95)',
               backdropFilter: 'blur(12px)',
               boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
               borderBottom: '1px solid hsl(214, 32%, 91%)',
            }}
            data-testid='navigation'
         >
            <Toolbar
               sx={{ maxWidth: '1280px', width: '100%', mx: 'auto', px: { xs: 2, sm: 3, lg: 4 } }}
            >
               <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                  <img
                     src={logo}
                     alt='WeTrippen'
                     style={{ height: '40px', width: 'auto', cursor: 'pointer' }}
                     onClick={() => navigate('/')}
                     data-testid='logo'
                  />
               </Box>

               <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3, alignItems: 'center' }}>
                     <Button
                     onClick={() => scrollToSection('features')}
                        sx={{
                        color: '#1F2937',
                           textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': { color: '#01949A' },
                        }}
                     data-testid='nav-features'
                     >
                        Features
                     </Button>
                     <Button
                     onClick={() => scrollToSection('how-it-works')}
                        sx={{
                        color: '#1F2937',
                           textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': { color: '#01949A' },
                        }}
                     data-testid='nav-how-it-works'
                     >
                        How It Works
                     </Button>
                     <Button
                     onClick={() => scrollToSection('pricing')}
                        sx={{
                        color: '#1F2937',
                           textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': { color: '#01949A' },
                        }}
                     data-testid='nav-pricing'
                     >
                     Pricing
                     </Button>
                     <Button
                     onClick={() => navigate('/about')}
                        sx={{
                        color: '#1F2937',
                           textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': { color: '#01949A' },
                        }}
                     data-testid='nav-about'
                     >
                     About
                     </Button>
               </Box>

                     <Button
                        variant='contained'
                  onClick={() => navigate('/signup')}
                        sx={{
                     ml: { xs: 2, md: 3 },
                     background: '#01949A',
                           color: 'white',
                           textTransform: 'none',
                     fontSize: '1rem',
                     fontWeight: 600,
                     px: 3,
                     borderRadius: 0,
                           '&:hover': {
                        background: '#007075',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 10px 25px rgba(20, 184, 166, 0.3)',
                           },
                     transition: 'all 0.3s ease',
                        }}
                  data-testid='nav-cta-signup'
                     >
                  Get Started Free
                     </Button>
            </Toolbar>
         </AppBar>

         {/* Hero Section */}
         <Box
            sx={{
               pt: { xs: 16, md: 18 },
               pb: { xs: 10, md: 12 },
               position: 'relative',
               color: 'white',
               minHeight: { xs: '85vh', md: '75vh' },
               display: 'flex',
               alignItems: 'center',
               overflow: 'hidden',
               backgroundColor: '#01949A !important',
               backgroundImage:
                  'radial-gradient(circle, rgba(255, 255, 255, 0.2) 1.5px, transparent 1.5px) !important',
               backgroundSize: '25px 25px !important',
            }}
            data-testid='hero-section'
         >
            <Container maxWidth='lg' sx={{ position: 'relative', zIndex: 2 }}>
               <Grid container spacing={4} alignItems='center'>
                  <Grid item xs={12} md={8}>
                           <Typography
                              variant='h1'
                              sx={{
                           fontSize: { xs: '3rem', sm: '4rem', md: '5rem' },
                           fontWeight: 700,
                           lineHeight: 1.1,
                           mb: 3,
                           color: 'white',
                        }}
                        data-testid='hero-headline'
                           >
                              Your City,
                              <br />
                              Your Crew,
                              <br />
                        Your Memories
                           </Typography>

                           <Typography
                              variant='h5'
                              sx={{
                           fontSize: { xs: '1rem', md: '1.15rem' },
                                 fontWeight: 400,
                           lineHeight: 1.6,
                           mb: 2.5,
                           opacity: 0.95,
                           maxWidth: '650px',
                           color: 'white',
                        }}
                        data-testid='hero-subheadline'
                     >
                        Stop losing touch after amazing experiences. WeTrippen transforms scattered
                        photos and dead group chats into lasting communities that grow stronger over
                        time.
                           </Typography>

                           <Typography
                              sx={{
                           fontSize: { xs: '1rem', md: '1.05rem' },
                                 fontWeight: 400,
                           mb: 4,
                           opacity: 0.9,
                           color: 'white',
                              }}
                        data-testid='hero-subtitle'
                           >
                        The complete platform for events, trips, and lasting connections
                           </Typography>

                        <Box
                           sx={{
                              display: 'flex',
                              flexDirection: { xs: 'column', sm: 'row' },
                           gap: 2,
                           mb: 2.5,
                           }}
                        >
                           <Button
                              variant='contained'
                           size='large'
                           onClick={() => navigate('/signup')}
                              sx={{
                              background: 'white',
                                 color: '#01949A',
                              px: 3.5,
                              py: 1.25,
                              fontSize: '1rem',
                              fontWeight: 600,
                                 textTransform: 'none',
                              borderRadius: '6px',
                              boxShadow: 'none',
                                 '&:hover': {
                                 background: '#f0f0f0',
                                 boxShadow: 'none',
                                 },
                              transition: 'all 0.2s ease',
                              }}
                           data-testid='hero-cta-primary'
                           >
                           Get Started Free
                           </Button>

                           <Button
                              variant='outlined'
                           size='large'
                           onClick={() => scrollToSection('how-it-works')}
                              sx={{
                              borderColor: 'rgba(255, 255, 255, 0.8)',
                                 color: 'white',
                              px: 3.5,
                              py: 1.25,
                              fontSize: '1rem',
                              fontWeight: 500,
                                 textTransform: 'none',
                              borderRadius: '6px',
                                 '&:hover': {
                                 borderColor: 'white',
                                 background: 'rgba(255, 255, 255, 0.1)',
                                 },
                              transition: 'all 0.2s ease',
                              }}
                           data-testid='hero-cta-secondary'
                           >
                           See How It Works
                           </Button>
         </Box>

                     <Typography
               sx={{
                           fontSize: '0.9rem',
                           opacity: 0.85,
                           color: 'white',
                        }}
                        data-testid='hero-trust-signal'
                     >
                        ✨ First event, trip, and album FREE • Then just $35/year for unlimited
                     </Typography>
                  </Grid>
               </Grid>
            </Container>
         </Box>

         {/* Features Section */}
         <Box
            id='features'
            sx={{ py: { xs: 8, md: 12 }, background: '#F9FAFB' }}
            data-testid='features-section'
         >
            <Container maxWidth='lg'>
               <Box sx={{ textAlign: 'center', mb: 8 }}>
                  <Typography
                     variant='h2'
                     sx={{
                        fontSize: { xs: '2rem', md: '3rem' },
                        fontWeight: 500,
                        color: '#1F2937',
                        mb: 2,
                     }}
                     data-testid='features-title'
                  >
                     Everything You Need in One Platform
                  </Typography>
                  <Typography sx={{ fontSize: '1.2rem', color: '#6B7280' }}>
                     From planning to memories—we've revolutionized how people connect
                  </Typography>
               </Box>

               <Grid container spacing={3}>
                  {/* Feature 1: Events */}
                  <Grid item xs={12} md={6} lg={4}>
                     <Box
                           sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                              transition: 'all 0.3s ease',
                              '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                              },
                           }}
                        >
                        <Ticket sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                        <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                        >
                           Events That Build Community
                        </Typography>
                        <Typography
                           sx={{ color: '#6B7280', mb: 3, lineHeight: 1.8, fontSize: '0.875rem' }}
                        >
                           • Create events in under 2 minutes
                           <br />
                           • Send invitations with QR codes
                           <br />
                           • Manage RSVPs and updates
                           <br />
                           • Public event pages for easy sharing
                           <br />• Event chat for coordination
                        </Typography>
                           <Box
                              sx={{
                              display: 'inline-block',
                              background: '#E0F2FE',
                              borderRadius: '16px',
                              px: 2,
                              py: 0.75,
                           }}
                        >
                           <Typography
                              sx={{ fontSize: '0.75rem', color: '#0369A1', fontWeight: 500 }}
                           >
                              Perfect for: Networking events, workshops, parties, meetups
                           </Typography>
                        </Box>
                     </Box>
                  </Grid>

                  {/* Feature 2: Trips */}
                  <Grid item xs={12} md={6} lg={4}>
                           <Box
                              sx={{
                                 height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           transition: 'all 0.3s ease',
                           '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                           },
                        }}
                     >
                        <Plane sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                                    <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                                    >
                           Trips That Bring People Together
                                    </Typography>
                                 <Typography
                           sx={{ color: '#6B7280', mb: 3, lineHeight: 1.8, fontSize: '0.875rem' }}
                        >
                           • Multi-day trip planning
                           <br />
                           • Coordinate dates and budgets
                           <br />
                           • Collaborative itineraries
                           <br />
                           • Trip-specific photo albums
                           <br />• Keep the group connected
                                 </Typography>
                        <Box
                                 sx={{
                              display: 'inline-block',
                              background: '#E0F2FE',
                              borderRadius: '16px',
                              px: 2,
                              py: 0.75,
                           }}
                        >
                           <Typography
                              sx={{ fontSize: '0.75rem', color: '#0369A1', fontWeight: 500 }}
                           >
                              Perfect for: Weekend getaways, bachelor parties, family reunions
                           </Typography>
                           </Box>
                     </Box>
                  </Grid>

                  {/* Feature 3: Photos */}
                  <Grid item xs={12} md={6} lg={4}>
                     <Box
                           sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                              transition: 'all 0.3s ease',
                              '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                              },
                           }}
                        >
                        <ImageIcon sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                        <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                        >
                           Photos That Live Forever
                        </Typography>
                        <Typography
                           sx={{ color: '#6B7280', mb: 3, lineHeight: 1.8, fontSize: '0.875rem' }}
                        >
                           • Everyone uploads photos to shared albums
                           <br />
                           • Organized automatically by event/trip
                           <br />
                           • Public albums with QR code access
                           <br />
                           • Beautiful photo timelines
                           <br />• Never lose a memory again
                        </Typography>
                           <Box
                              sx={{
                              display: 'inline-block',
                              background: '#E0F2FE',
                              borderRadius: '16px',
                              px: 2,
                              py: 0.75,
                           }}
                        >
                           <Typography
                              sx={{ fontSize: '0.75rem', color: '#0369A1', fontWeight: 500 }}
                           >
                              Perfect for: Weddings, conferences, retreats, celebrations
                           </Typography>
                        </Box>
                     </Box>
                  </Grid>

                  {/* Feature 4: Profiles */}
                  <Grid item xs={12} md={6} lg={4}>
                           <Box
                              sx={{
                                 height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           transition: 'all 0.3s ease',
                           '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                           },
                        }}
                     >
                        <UserCircle sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                                    <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                                    >
                           Profiles That Open Doors
                                    </Typography>
                                 <Typography
                           sx={{ color: '#6B7280', mb: 3, lineHeight: 1.8, fontSize: '0.875rem' }}
                        >
                           • Digital business card with QR code
                           <br />
                           • Track who views your profile
                           <br />
                           • Build your network organically
                           <br />
                           • Connect at events instantly
                           <br />• See your connection timeline
                                 </Typography>
                                 <Box
                                    sx={{
                              display: 'inline-block',
                              background: '#E0F2FE',
                              borderRadius: '16px',
                              px: 2,
                              py: 0.75,
                           }}
                        >
                           <Typography
                              sx={{ fontSize: '0.75rem', color: '#0369A1', fontWeight: 500 }}
                           >
                              Perfect for: Professionals, organizers, community builders
                                       </Typography>
                                    </Box>
                                    </Box>
                  </Grid>

                  {/* Feature 5: Coordination */}
                  <Grid item xs={12} md={6} lg={4}>
                     <Box
                           sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           transition: 'all 0.3s ease',
                              '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                              },
                           }}
                        >
                        <Calendar sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                                       <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                                       >
                           Seamless Coordination
                                       </Typography>
                                    <Typography
                           sx={{ color: '#6B7280', mb: 3, lineHeight: 1.8, fontSize: '0.875rem' }}
                        >
                           • Visual calendar of all events & trips
                           <br />
                           • Sync to your personal calendar
                           <br />
                           • Timeline view of your experiences
                           <br />
                           • Never miss a moment
                           <br />• Track your community growth
                                    </Typography>
                                    <Box
                           sx={{
                              display: 'inline-block',
                              background: '#E0F2FE',
                              borderRadius: '16px',
                              px: 2,
                              py: 0.75,
                           }}
                        >
                           <Typography
                              sx={{ fontSize: '0.75rem', color: '#0369A1', fontWeight: 500 }}
                           >
                              Perfect for: Busy professionals, serial organizers
                                          </Typography>
                                       </Box>
                                       </Box>
                  </Grid>

                  {/* Feature 6: QR Codes */}
                  <Grid item xs={12} md={6} lg={4}>
                     <Box
                                       sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           transition: 'all 0.3s ease',
                                          '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                          },
                                       }}
                                    >
                        <QrCode sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                        <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                        >
                           QR Codes That Connect
                        </Typography>
                        <Typography
                           sx={{ color: '#6B7280', mb: 3, lineHeight: 1.8, fontSize: '0.875rem' }}
                        >
                           • Profile QR codes
                           <br />
                           • Event QR codes
                           <br />
                           • Album QR codes
                           <br />
                           • Print business cards (coming soon)
                           <br />• Track scans and engagement
                        </Typography>
                                 <Box
                                    sx={{
                              display: 'inline-block',
                              background: '#E0F2FE',
                              borderRadius: '16px',
                              px: 2,
                              py: 0.75,
                           }}
                        >
                           <Typography
                              sx={{ fontSize: '0.75rem', color: '#0369A1', fontWeight: 500 }}
                           >
                              Perfect for: Networking, event promotion, photo sharing
                           </Typography>
                        </Box>
                     </Box>
                  </Grid>
               </Grid>
            </Container>
         </Box>

         {/* How It Works Section */}
         <Box id='how-it-works' sx={{ py: { xs: 8, md: 12 } }} data-testid='how-it-works-section'>
            <Container maxWidth='lg'>
                  <Typography
                     variant='h2'
                  align='center'
                     sx={{
                     fontSize: { xs: '2rem', md: '3rem' },
                     fontWeight: 500,
                     color: '#1F2937',
                     mb: 8,
                  }}
                  data-testid='how-it-works-title'
               >
                  From Idea to Lasting Community in 4 Simple Steps
                  </Typography>

               <Grid container spacing={6}>
                  <Grid item xs={12} sm={6} md={3}>
                     <Box sx={{ textAlign: 'center' }}>
                        <Box
                     sx={{
                              width: 80,
                              height: 80,
                              borderRadius: '50%',
                              background: 'linear-gradient(135deg, #01949A 0%, #1e3c72 100%)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                        mx: 'auto',
                              mb: 3,
                              color: 'white',
                              fontSize: '2rem',
                              fontWeight: 600,
                           }}
                        >
                           1
                        </Box>
                        <Typography variant='h5' sx={{ fontWeight: 500, color: '#1F2937', mb: 2 }}>
                           CREATE
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                           Create your first event or trip in minutes. Add details, pick a date, set
                           your vibe.
                  </Typography>
               </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                     <Box sx={{ textAlign: 'center' }}>
                  <Box
                     sx={{
                              width: 80,
                              height: 80,
                                       borderRadius: '50%',
                              background: 'linear-gradient(135deg, #01949A 0%, #1e3c72 100%)',
                                       display: 'flex',
                                       alignItems: 'center',
                                       justifyContent: 'center',
                                       mx: 'auto',
                                       mb: 3,
                              color: 'white',
                              fontSize: '2rem',
                              fontWeight: 600,
                           }}
                        >
                           2
                        </Box>
                        <Typography variant='h5' sx={{ fontWeight: 500, color: '#1F2937', mb: 2 }}>
                           INVITE
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                           Share via QR code, link, or direct invitation. Watch RSVPs roll in
                           automatically.
                        </Typography>
                     </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                     <Box sx={{ textAlign: 'center' }}>
                                    <Box
                                       sx={{
                              width: 80,
                              height: 80,
                                          borderRadius: '50%',
                              background: 'linear-gradient(135deg, #01949A 0%, #1e3c72 100%)',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                              mx: 'auto',
                              mb: 3,
                              color: 'white',
                              fontSize: '2rem',
                              fontWeight: 600,
                           }}
                        >
                           3
                                    </Box>
                        <Typography variant='h5' sx={{ fontWeight: 500, color: '#1F2937', mb: 2 }}>
                           CONNECT
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                           People meet, exchange profiles, upload photos. Everyone stays in the
                           loop.
                        </Typography>
                                 </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                                 <Box sx={{ textAlign: 'center' }}>
                        <Box
                                       sx={{
                              width: 80,
                              height: 80,
                              borderRadius: '50%',
                              background: 'linear-gradient(135deg, #01949A 0%, #1e3c72 100%)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                                          mx: 'auto',
                              mb: 3,
                              color: 'white',
                              fontSize: '2rem',
                              fontWeight: 600,
                           }}
                        >
                           4
                        </Box>
                        <Typography variant='h5' sx={{ fontWeight: 500, color: '#1F2937', mb: 2 }}>
                           GROW
                                    </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                           Your network grows with every event. Connections deepen. Community forms
                           naturally.
                                    </Typography>
                                 </Box>
                        </Grid>
                  </Grid>
            </Container>
         </Box>

         {/* Use Cases Section */}
         <Box sx={{ py: { xs: 8, md: 12 } }} data-testid='use-cases-section'>
            <Container maxWidth='lg'>
            <Typography
                     variant='h2'
                  align='center'
               sx={{
                     fontSize: { xs: '2rem', md: '3rem' },
                     fontWeight: 500,
                     color: '#1F2937',
                     mb: 8,
                  }}
                  data-testid='use-cases-title'
               >
                  Built for Everyone Who Brings People Together
            </Typography>

               <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={4}>
                     <Box
                     sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           textAlign: 'center',
                           transition: 'all 0.3s ease',
                           '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                           },
                        }}
                     >
                        <Briefcase sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                        <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                        >
                           Professional Networkers
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7, fontSize: '0.9rem' }}>
                           Host networking events, build your professional community, and grow your
                           influence.
                  </Typography>
               </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                     <Box
                     sx={{
                                  height: '100%',
                           borderRadius: 2,
                                  background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           textAlign: 'center',
                                  transition: 'all 0.3s ease',
                                  '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                  },
                               }}
                            >
                        <PartyPopper sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                        <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                        >
                           Social Organizers
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7, fontSize: '0.9rem' }}>
                           Plan parties, coordinate friend groups, and keep your social calendar
                           thriving.
                        </Typography>
                     </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                     <Box
                                       sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           textAlign: 'center',
                           transition: 'all 0.3s ease',
                           '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                           },
                        }}
                     >
                        <Heart sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                        <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                        >
                           Families
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7, fontSize: '0.9rem' }}>
                           Organize reunions, share photos across generations, and stay connected.
                        </Typography>
                                 </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                     <Box
                        sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           textAlign: 'center',
                           transition: 'all 0.3s ease',
                           '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                       },
                                    }}
                                 >
                        <Dumbbell sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                     <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                        >
                           Activity Groups
                     </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7, fontSize: '0.9rem' }}>
                           Run hiking clubs, sports leagues, book clubs—any recurring group
                           activity.
                        </Typography>
                     </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                     <Box
                                       sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           textAlign: 'center',
                           transition: 'all 0.3s ease',
                           '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                       },
                                    }}
                                 >
                        <Building2 sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                                       <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                                       >
                           Small Organizations
                           </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7, fontSize: '0.9rem' }}>
                           Chambers of commerce, professional associations, cultural groups, and
                           communities.
                        </Typography>
                     </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                     <Box
                                          sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: 'white',
                           border: '1px solid #E5E7EB',
                           p: 4,
                           textAlign: 'center',
                           transition: 'all 0.3s ease',
                           '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                           },
                        }}
                     >
                        <Camera sx={{ fontSize: 48, color: '#01949A', mb: 3 }} />
                                       <Typography
                           variant='h6'
                           sx={{ fontWeight: 500, color: '#1F2937', mb: 2, fontSize: '1.125rem' }}
                                       >
                           Event Photographers
                           </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7, fontSize: '0.9rem' }}>
                           Share photos with clients, build your portfolio, and grow your business.
                           </Typography>
                                    </Box>
                     </Grid>
               </Grid>
         </Container>
         </Box>

         {/* Problem Section - Commented Out */}
         {/* <Box sx={{ py: { xs: 8, md: 12 } }} data-testid='problem-section'>
            <Container maxWidth='lg'>
                                       <Typography
                  variant='h2'
                  align='center'
               sx={{
                     fontSize: { xs: '2rem', md: '3rem' },
                     fontWeight: 700,
                     color: '#1F2937',
                     mb: 8,
                  }}
                  data-testid='problem-title'
               >
                  You Know This Feeling...
               </Typography>

               <Grid container spacing={4}>
                  <Grid item xs={12} md={4}>
                     <Box sx={{ textAlign: 'center' }}>
                        <Box sx={{ fontSize: '4rem', mb: 2 }}>📱</Box>
                        <Typography variant='h5' sx={{ fontWeight: 700, color: '#1F2937', mb: 2 }}>
                           Scattered Photos
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                           You take hundreds of photos at events, they sit in your phone, and nobody
                           ever sees them. Group chats die. Memories fade.
                           </Typography>
                                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                     <Box sx={{ textAlign: 'center' }}>
                        <Box sx={{ fontSize: '4rem', mb: 2 }}>😞</Box>
                        <Typography variant='h5' sx={{ fontWeight: 700, color: '#1F2937', mb: 2 }}>
                           Lost Connections
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                           You meet amazing people at events, exchange numbers, and never follow up.
                           Your network stays shallow.
                        </Typography>
                        </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                     <Box sx={{ textAlign: 'center' }}>
                        <Box sx={{ fontSize: '4rem', mb: 2 }}>🤯</Box>
                        <Typography variant='h5' sx={{ fontWeight: 700, color: '#1F2937', mb: 2 }}>
                           Planning Chaos
                        </Typography>
                        <Typography sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                           You coordinate events across 10 different apps. Group chats get messy.
                           Half your guests miss important updates.
                        </Typography>
                     </Box>
                     </Grid>
               </Grid>

               <Box sx={{ textAlign: 'center', mt: 6 }}>
                  <Typography
                     sx={{
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        color: '#01949A',
                        cursor: 'pointer',
                     }}
                     onClick={() => scrollToSection('features')}
                     data-testid='problem-cta'
                  >
                     There's a better way. →
                  </Typography>
               </Box>
            </Container>
         </Box> */}

         {/* Pricing Section */}
         <Box id='pricing' sx={{ py: { xs: 8, md: 12 } }} data-testid='pricing-section'>
            <Container maxWidth='lg'>
               <Box sx={{ textAlign: 'center', mb: 6 }}>
                  <Typography
                     variant='h2'
                     sx={{
                        fontSize: { xs: '1.75rem', md: '2.25rem' },
                        fontWeight: 500,
                        color: '#1F2937',
                        mb: 1,
                     }}
                     data-testid='pricing-title'
                  >
                     Simple, Transparent Pricing
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', color: '#6B7280' }}>
                     No hidden fees. No credit card required to start.
                  </Typography>
               </Box>

               <Grid container spacing={3} justifyContent='center' maxWidth='900px' mx='auto'>
                  {/* Personal Account */}
                  <Grid item xs={12} md={6}>
                           <Card
                              sx={{
                                 height: '100%',
                           borderRadius: 2,
                           border: '1px solid #01949A',
                                 position: 'relative',
                           boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        }}
                     >
                        <CardContent sx={{ p: 3 }}>
                           <Typography
                              variant='h5'
                              sx={{ fontWeight: 500, color: '#1F2937', mb: 0.5 }}
                           >
                              Personal Account
                           </Typography>
                           <Typography sx={{ color: '#6B7280', mb: 2, fontSize: '0.9rem' }}>
                              Perfect for individuals & small groups
                           </Typography>

                           <Box sx={{ mb: 2 }}>
                                    <Typography
                                 sx={{ fontSize: '0.85rem', color: '#6B7280', fontWeight: 500 }}
                              >
                                 FREE TO START
                                    </Typography>
                              <Box sx={{ display: 'flex', alignItems: 'baseline', mb: 0.5 }}>
                                    <Typography
                                    variant='h3'
                                    sx={{ fontWeight: 500, color: '#01949A' }}
                                 >
                                    $35
                                    </Typography>
                                 <Typography sx={{ color: '#6B7280', ml: 1, fontSize: '0.9rem' }}>
                                    /year
                                 </Typography>
                              </Box>
                           </Box>

                           <Box sx={{ mb: 2, p: 1.5, background: '#F0FDF4', borderRadius: 1 }}>
                                       <Typography
                                 sx={{ fontSize: '0.85rem', color: '#065F46', fontWeight: 400 }}
                              >
                                 ✅ First event FREE
                                 <br />
                                 ✅ First trip FREE
                                 <br />
                                 ✅ First album FREE
                                 <br />
                                 <br />
                                 Then unlimited for $35/year
                                       </Typography>
                           </Box>

                                       <Typography
                              variant='subtitle2'
                                          sx={{
                                             fontWeight: 500,
                                 color: '#1F2937',
                                  mb: 1.5,
                                             fontSize: '0.9rem',
                                          }}
                                       >
                               What's included:
                           </Typography>
                           <Box sx={{ mb: 2 }}>
                              {[
                                 'Unlimited events & trips',
                                 'Unlimited photo storage',
                                 'QR code profile & sharing',
                                 'Event & trip management',
                                 'Collaborative photo albums',
                                 'Calendar & timeline views',
                                 'Mobile app access',
                                 'Network building tools',
                              ].map((feature) => (
                                 <Box
                                    key={feature}
                                    sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}
                                 >
                                    <Check sx={{ fontSize: 16, color: '#01949A', mr: 1 }} />
                                    <Typography sx={{ color: '#1F2937', fontSize: '0.875rem' }}>
                                       {feature}
                                       </Typography>
                                 </Box>
                              ))}
                                    </Box>

                           <Box sx={{ mb: 2, p: 1.5, background: '#FEF3C7', borderRadius: 1 }}>
                                       <Typography
                                 sx={{ fontSize: '0.8rem', color: '#92400E', fontWeight: 400 }}
                              >
                                 🎁 BONUS: First 1,000 users get:
                                 <br />
                                 • Lifetime free QR code downloads
                                 <br />• Early access to new features
                              </Typography>
                           </Box>

                           <Button
                              variant='contained'
                              fullWidth
                              onClick={() => navigate('/signup')}
                                          sx={{
                                 background: '#01949A',
                                 color: 'white',
                                 py: 1.25,
                                 fontSize: '0.95rem',
                                             fontWeight: 500,
                                 textTransform: 'none',
                                 '&:hover': {
                                    background: '#007075',
                                 },
                                 transition: 'all 0.2s ease',
                              }}
                              data-testid='pricing-cta-personal'
                           >
                              Get Started Free →
                           </Button>
                        </CardContent>
                     </Card>
                  </Grid>

                  {/* Organization Account */}
                  <Grid item xs={12} md={6}>
                     <Card
                        sx={{
                           height: '100%',
                           borderRadius: 2,
                           background: '#F9FAFB',
                           border: '1px solid #E5E7EB',
                        }}
                     >
                        <CardContent sx={{ p: 3 }}>
                           <Typography
                              variant='h5'
                              sx={{ fontWeight: 600, color: '#1F2937', mb: 0.5 }}
                           >
                              Organization Account
                                       </Typography>
                           <Typography sx={{ color: '#6B7280', mb: 2, fontSize: '0.9rem' }}>
                              For communities & businesses
                           </Typography>

                           <Chip
                              label='COMING SOON'
                              sx={{
                                 background: '#6B7280',
                                 color: 'white',
                                 fontWeight: 600,
                                 mb: 2,
                                 fontSize: '0.75rem',
                              }}
                              size='small'
                           />

                                    <Typography
                                       variant='subtitle2'
                                       sx={{
                                 fontWeight: 500,
                                 color: '#1F2937',
                                          mb: 1.5,
                                  mt: 2,
                                          fontSize: '0.9rem',
                                       }}
                                    >
                               Perfect for:
                                    </Typography>
                           <Box sx={{ mb: 2 }}>
                              {[
                                 'Professional associations',
                                 'Chambers of commerce',
                                 'Community organizations',
                                 'Event companies',
                                 'Membership groups',
                              ].map((item) => (
                                 <Box
                                    key={item}
                                    sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}
                                 >
                                    <Check sx={{ fontSize: 16, color: '#6B7280', mr: 1 }} />
                                    <Typography sx={{ color: '#6B7280', fontSize: '0.875rem' }}>
                                       {item}
                                    </Typography>
                                 </Box>
                              ))}
                           </Box>

                                          <Typography
                              variant='subtitle2'
                                             sx={{
                                 fontWeight: 500,
                                 color: '#1F2937',
                                 mb: 1.5,
                                 fontSize: '0.9rem',
                              }}
                           >
                              Features will include:
                           </Typography>
                           <Box sx={{ mb: 2 }}>
                              {[
                                 'Member management',
                                 'Ticket sales (no fees!)',
                                 'White-label options',
                                 'Advanced analytics',
                                 'Custom branding',
                                 'Priority support',
                                 'Bulk invitations',
                                 'And much more...',
                              ].map((feature) => (
                                 <Box
                                    key={feature}
                                    sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}
                                 >
                                    <Check sx={{ fontSize: 16, color: '#6B7280', mr: 1 }} />
                                    <Typography sx={{ color: '#6B7280', fontSize: '0.875rem' }}>
                                             {feature}
                                          </Typography>
                                       </Box>
                                    ))}
                                 </Box>

                           <Button
                              variant='outlined'
                              fullWidth
                              sx={{
                                 borderColor: '#6B7280',
                                 color: '#6B7280',
                                 py: 1.25,
                                 fontSize: '0.95rem',
                                 fontWeight: 500,
                                 textTransform: 'none',
                                 '&:hover': {
                                    borderColor: '#374151',
                                    background: '#F3F4F6',
                                 },
                              }}
                              data-testid='pricing-cta-organization'
                           >
                              Join Waitlist →
                           </Button>
                        </CardContent>
                           </Card>
                     </Grid>
               </Grid>
            </Container>
         </Box>

         {/* Final CTA Section */}
         <Box
            sx={{
               py: { xs: 10, md: 14 },
               backgroundColor: '#01949A !important',
               backgroundImage:
                  'radial-gradient(circle, rgba(255, 255, 255, 0.2) 1.5px, transparent 1.5px) !important',
               backgroundSize: '25px 25px !important',
               color: 'white',
               position: 'relative',
               overflow: 'hidden',
            }}
            data-testid='final-cta-section'
         >
            <Container maxWidth='md' sx={{ position: 'relative', zIndex: 2 }}>
               <Box sx={{ textAlign: 'center' }}>
                  <Typography
                     variant='h2'
               sx={{
                        fontSize: { xs: '2rem', md: '3.5rem' },
                        fontWeight: 500,
                        mb: 3,
                     }}
                     data-testid='final-cta-title'
                  >
                     Ready to Stop Losing Touch?
               </Typography>

                  <Typography
                  sx={{
                        fontSize: { xs: '1.1rem', md: '1.3rem' },
                        mb: 5,
                        opacity: 0.95,
                        lineHeight: 1.6,
                     }}
                     data-testid='final-cta-subtitle'
                  >
                     Join thousands of people who've discovered what happens when you stop hoping
                     for community and start building it.
                  </Typography>

                  <Button
                     variant='contained'
                     size='large'
                     onClick={() => navigate('/signup')}
                     sx={{
                        background: 'white',
                        color: '#01949A',
                        px: 6,
                        py: 2,
                        fontSize: '1.2rem',
                        fontWeight: 500,
                        textTransform: 'none',
                        borderRadius: '8px',
                        mb: 3,
                        '&:hover': {
                           background: '#f9fafb',
                           transform: 'translateY(-3px)',
                           boxShadow: '0 15px 35px rgba(0, 0, 0, 0.3)',
                        },
                        transition: 'all 0.3s ease',
                     }}
                     data-testid='final-cta-button'
                  >
                     Get Started Free
                  </Button>

                  <Typography sx={{ opacity: 0.9, fontSize: '0.95rem', mb: 3 }}>
                     No credit card required • First event, trip & album free • $35/year after that
                  </Typography>

                           <Box
                              sx={{
                                 display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 2,
                                 justifyContent: 'center',
                        mt: 4,
                     }}
                  >
                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Check sx={{ fontSize: 20 }} />
                        <Typography sx={{ fontSize: '0.95rem' }}>2,847 active users</Typography>
                           </Box>
                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Check sx={{ fontSize: 20 }} />
                        <Typography sx={{ fontSize: '0.95rem' }}>
                           First 1,000 users get free QR codes for life
                           </Typography>
                        </Box>
                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Check sx={{ fontSize: 20 }} />
                        <Typography sx={{ fontSize: '0.95rem' }}>
                           Cancel anytime (but you won't want to)
                        </Typography>
                     </Box>
                  </Box>
               </Box>
            </Container>
         </Box>

         {/* Footer */}
         <Box sx={{ py: 8, background: '#1F2937', color: 'white' }} data-testid='footer'>
            <Container maxWidth='lg'>
                     <Grid container spacing={4}>
                  <Grid item xs={12} sm={6} md={3}>
                     <Typography variant='h6' sx={{ fontWeight: 500, mb: 2 }}>
                              Product
                           </Typography>
                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                 <Button
                           onClick={() => scrollToSection('features')}
                                    sx={{
                              color: '#9CA3AF',
                              textTransform: 'none',
                                       justifyContent: 'flex-start',
                                       p: 0,
                           }}
                        >
                           Features
                                 </Button>
                        <Button
                           onClick={() => scrollToSection('how-it-works')}
                              sx={{
                              color: '#9CA3AF',
                              textTransform: 'none',
                              justifyContent: 'flex-start',
                              p: 0,
                           }}
                        >
                           How It Works
                        </Button>
                                 <Button
                           onClick={() => scrollToSection('pricing')}
                                    sx={{
                              color: '#9CA3AF',
                              textTransform: 'none',
                                       justifyContent: 'flex-start',
                                       p: 0,
                           }}
                        >
                           Pricing
                                 </Button>
                           </Box>
               </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                     <Typography variant='h6' sx={{ fontWeight: 500, mb: 2 }}>
                        Company
                     </Typography>
                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Button
                           onClick={() => navigate('/about')}
                  sx={{
                              color: '#9CA3AF',
                              textTransform: 'none',
                              justifyContent: 'flex-start',
                              p: 0,
                           }}
                        >
                           About Us
                        </Button>
                        <Button
                           onClick={() => navigate('/ambassador')}
                     sx={{
                              color: '#9CA3AF',
                              textTransform: 'none',
                              justifyContent: 'flex-start',
                              p: 0,
                           }}
                        >
                           Ambassador Program
                        </Button>
                        {/* <Button
                           onClick={() => navigate('/contact')}
                        sx={{
                              color: '#9CA3AF',
                              textTransform: 'none',
                              justifyContent: 'flex-start',
                              p: 0,
                           }}
                        >
                           Contact Us
                        </Button> */}
                     </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                     <Typography variant='h6' sx={{ fontWeight: 500, mb: 2 }}>
                        Legal
                     </Typography>
                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Button
                           onClick={() => navigate('/terms-and-conditions')}
                        sx={{
                              color: '#9CA3AF',
                              textTransform: 'none',
                              justifyContent: 'flex-start',
                              p: 0,
                           }}
                        >
                           Terms of Service
                        </Button>
                     </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                     <Typography variant='h6' sx={{ fontWeight: 500, mb: 2 }}>
                        Connect
                     </Typography>
                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography sx={{ color: '#9CA3AF', fontSize: '0.9rem' }}>
                           Twitter/X
                        </Typography>
                        <Typography sx={{ color: '#9CA3AF', fontSize: '0.9rem' }}>
                           LinkedIn
                        </Typography>
                        <Typography sx={{ color: '#9CA3AF', fontSize: '0.9rem' }}>
                           Instagram
                        </Typography>
                        <Typography sx={{ color: '#9CA3AF', fontSize: '0.9rem' }}>
                           Email: info@wetrippen.com
                     </Typography>
                  </Box>
                  </Grid>
               </Grid>

               <Box sx={{ borderTop: '1px solid #374151', mt: 6, pt: 4, textAlign: 'center' }}>
                  <Typography sx={{ color: '#9CA3AF', fontSize: '0.9rem' }}>
                     © 2024 WeTrippen by Align Workspace Inc. • Made with ❤️ in Philadelphia
                  </Typography>
               </Box>
            </Container>
         </Box>
      </div>
   );
}
